export default __webpack_public_path__ + "static/media/Bike.d36602d4.png";